import { BundleMiniItem, BundleLaundryMiniItem } from './bundle-item';

const Templates = {
  BundleMiniItem,
  BundleLaundryMiniItem
};

export const getTemplate = (templateName) => Templates?.[templateName] || null;